// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconStore2 = createRemixIcon('IconStore2', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.382 0h15.236l.276.553l2 4l.106.21V11h-.75v13H2.75V11H2V4.764l.106-.211l2-4zm.868 18.5v3h6.5v-3zm0-2.5h6.5v-5h-6.5zm13.5 5.5h-4.5V11h4.5z\" clip-rule=\"evenodd\"/>");
